import React from 'react';
import { ICustomizableElement, ITestingElement } from '@insurancemenu/imenu-components-lib/dist/types';
import { TitleStyled } from './styles';

export interface SectionCategoryTitleProps extends ICustomizableElement, ITestingElement {
  text: string;
}

const SectionTitleCaps: React.FC<SectionCategoryTitleProps> = ({ text, className, 'data-test-id': dataTestId }) => {
  return (
    <TitleStyled className={className} data-test-id={dataTestId}>
      {text}
    </TitleStyled>
  );
};

export default SectionTitleCaps;
